import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { DynamicTreeDataSourceOptions, NodeData } from '../../../ui/gzTree/type';
import { TreeDetails } from '../types';
import { NodeChildrenResponse } from '../../networkAppContainer/helpers/types';

export class NetworkTreeBaseDataProvider extends BaseWebComponentDataProvider {
  protected options: DynamicTreeDataSourceOptions;

  public getOptions(): DynamicTreeDataSourceOptions {
    return this.options;
  }

  public async getRootNode(): Promise<NodeData> {
    throw Error('Needs to be implemented.');
  }

  public async getNodeChildren(targetNode: NodeData): Promise<{ currentNode: NodeData; childNodes: NodeData[] }> {
    throw Error('Needs to be implemented.');
  }

  public async getTreeNodesForChild(treeDetails: TreeDetails): Promise<NodeChildrenResponse> {
    throw Error('Needs to be implemented.');
  }
}
